import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function getToken() {
  return localStorage.getItem("access_token");
}
export function setTokens(access, refresh) {
  if (access) localStorage.setItem("access_token", access);
  if (refresh) localStorage.setItem("refresh_token", refresh);
}
export function clearTokens() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
}

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach Bearer token to every request (robust across cookie-restricted browsers)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("access_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 401 && original && !original._retry && !url.includes("/auth/")) {
      original._retry = true;
      const rt = localStorage.getItem("refresh_token");
      if (!rt) {
        clearTokens();
        return Promise.reject(error);
      }
      try {
        refreshing = refreshing || api.post("/auth/refresh", { refresh_token: rt });
        const { data } = await refreshing;
        refreshing = null;
        if (data?.access_token) setTokens(data.access_token, null);
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${localStorage.getItem("access_token")}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        clearTokens();
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
